import { cn } from '../utils/cn';
import { formatFullNumber } from '../utils/formatters';
import { Icon, type IconName } from './ui/Icon';

interface ShipStatsProps {
    stats: { attack: number; life: number; cargo: number; speed: number };
    hangar?: number;
    className?: string;
}

const STAT_ROWS: { key: 'attack' | 'life' | 'cargo' | 'speed'; icon: IconName; label: string }[] = [
    { key: 'attack', icon: 'attack', label: 'Attack' },
    { key: 'life', icon: 'life', label: 'Life' },
    { key: 'cargo', icon: 'cargo', label: 'Cargo' },
    { key: 'speed', icon: 'speed', label: 'Speed' },
];

const ITEM_CLASSES = 'inline-flex items-center gap-1 whitespace-nowrap';

/**
 * Inline icon-plus-value run for a ship's combat and logistics stats — the one
 * renderer shared by the Factory and Tech Center cards. Speed is left out for a
 * ship that cannot move; `hangar` (population cost) is optional.
 */
export default function ShipStats({ stats, hangar, className }: ShipStatsProps) {
    return (
        <span className={cn('inline-flex flex-wrap items-center gap-x-3 gap-y-0.5 align-middle', className)}>
            {STAT_ROWS.filter(({ key }) => key !== 'speed' || stats.speed > 0).map(({ key, icon, label }) => (
                <span key={key} data-stat={key} title={label} className={ITEM_CLASSES}>
                    <Icon name={icon} size={14} />
                    <span>{formatFullNumber(stats[key])}</span>
                    <span className="sr-only">{` ${label}`}</span>
                </span>
            ))}
            {hangar !== undefined && (
                <span data-stat="hangar" title="Population cost" className={ITEM_CLASSES}>
                    <Icon name="population" size={14} />
                    <span>{formatFullNumber(hangar)} pop</span>
                </span>
            )}
        </span>
    );
}
